import { Anchor as MantineAnchor } from "@mantine/core"
import classNames from "./anchor.module.css"

export const Anchor = MantineAnchor.extend({
  classNames,
  defaultProps: {
    underline: "never",
  },
})

declare module "@mantine/core" {
  export interface AnchorProps {
    variant?: "link" | "text"
  }
}
